__turbopack_context__.v({
  "button": "button-module-scss-module__LDl9KG__button",
  "disabled": "button-module-scss-module__LDl9KG__disabled",
  "ghost": "button-module-scss-module__LDl9KG__ghost",
  "inverted": "button-module-scss-module__LDl9KG__inverted",
  "primary": "button-module-scss-module__LDl9KG__primary",
  "secondary": "button-module-scss-module__LDl9KG__secondary",
  "tertiary": "button-module-scss-module__LDl9KG__tertiary",
  "wrapper": "button-module-scss-module__LDl9KG__wrapper",
});
